document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', e => {
        e.preventDefault();
    })
})

const mobileQuery = window.matchMedia('(max-width: 768px)');

function handleDeviceChange(e) {
    if (e.matches) {
        document.body.classList.add('mobile-view');
    } else {
        document.body.classList.remove('mobile-view');
    }
}

handleDeviceChange(mobileQuery);
mobileQuery.addEventListener('change', handleDeviceChange);